// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"List_wrapper__3IAM_","organizationListHeader":"List_organizationListHeader__1HYNX"};